module.exports = __webpack_public_path__ + "img/step_bottom_separate.fe6518be.svg";